import { adaptPmsSubscriptionToSubscription } from 'features/purchase/pms/adaptPmsSubscription'
import { pmsApi } from 'features/purchase/pms/pmsApi'
import { CurrentSubscription } from 'types/subscription'

export const getCurrentSubscriptionFromPms = async (
	locale: string,
): Promise<CurrentSubscription> => {
	const subscription = await pmsApi.getUserSubscription()
	return subscription
		? adaptPmsSubscriptionToSubscription(subscription, locale)
		: null
}
